import React from 'react';

var OrderUnfulfilledItems = function OrderUnfulfilledItems(props) {
  var lines = props.lines;
  return React.createElement("div", null, React.createElement("h1", null, "Unfulfilled Items"), lines.map(function (line) {
    return React.createElement(React.Fragment, null, React.createElement("p", null, line.id, " -", line.productName, " -", line.productSku, " -", line.quantity - line.quantityFulfilled, " -"));
  }));
};

export default OrderUnfulfilledItems;